import { AutoCompleteSelect } from '@components/core-ui/form-elements/AutocompleteSelect';
import { TProps as AutoCompleteSelectProps } from '@components/core-ui/form-elements/AutocompleteSelect/types/TProps';

import { options } from './helpers/options';

export const TimeZoneSelect = (props: Omit<AutoCompleteSelectProps, 'options'>) => {
  return <AutoCompleteSelect {...props} options={options} />;
};
